import { Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

import { OccurrenceImportResponse } from "../../../../../models/occurrenceImport";

interface ImportResultProps {
    show: boolean
    selectedFile: File | null
    importResponse: OccurrenceImportResponse

    onClose: () => void
}

export const ImportResult = (props: ImportResultProps) => {
    const intl = useIntl();

    return (
        <Dialog
            show={props.show}
            onClose={props.onClose}
            bsSize="md"
            showCloseButton
            onCloseValidation={() => true}
            title={
                <div className="flex flex-col gap-2">
                    <h2 className="font-semibold text-[16px] m-0">
                        {intl.formatMessage({ id: "occurrence.import.create" })}
                    </h2>

                    <div className="flex items-center gap-3 text-[#697a8b] text-[12px]">
                        <span className="max-w-[240px] truncate" title={props.selectedFile?.name}>
                            {props.selectedFile?.name || "-"}
                        </span>
                        <span className="inline-flex items-center gap-1 rounded-full border border-[#9ad9b0] bg-[#e8f8ee] px-3 py-1 text-[#1e8a49] font-semibold">
                            <span className="rioglyph rioglyph-ok-circle" aria-hidden="true" />
                            {intl.formatMessage({ id: "occurrence.import.importDone" })}
                        </span>
                    </div>
                </div>
            }
            body={
                <div className="p-2">
                    <div className="alert alert-dismissible alert-success mb-8 p-4">
                        <div className="display-flex gap-10">
                            <span className="text-color-success text-size-h4 rioglyph rioglyph-ok-sign" />
                            <div>
                                <strong className="text-size-14 text-color-success">
                                    {intl.formatMessage({ id: "occurrence.import.importSuccess" })}
                                </strong>
                            </div>
                        </div>
                    </div>
                    
                    <div className="alert alert-dismissible alert-info mb-8 p-4">
                        <div className="display-flex gap-10">
                            <span className="text-color-info text-size-h4 rioglyph rioglyph-info-sign" />
                            <div>
                                <strong className="text-size-14 text-color-info">
                                    {intl.formatMessage({ id: "occurrence.import.info" })}
                                </strong>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 text-[16px] mb-4">
                        <span>
                            {intl.formatMessage(
                                { id: "occurrence.import.totalLines" },
                                { totalLines: props.importResponse.imported + props.importResponse.failed, b: (chunks) => <strong>{chunks}</strong> }
                            )}
                        </span>
                        <span className="h-6 w-px bg-[#d9e1e8] mx-4" />
                        <span className="text-[#1e8a49]">
                            {intl.formatMessage(
                                { id: "occurrence.import.successCount" },
                                { count: props.importResponse.imported, b: (chunks) => <strong>{chunks}</strong> }
                            )}
                        </span>
                        <span className="h-6 w-px bg-[#d9e1e8] mx-4" />
                        <span className="text-[#c74a4a]">
                            {intl.formatMessage(
                                { id: "occurrence.import.errorOnlyCount" },
                                { count: props.importResponse.failed, b: (chunks) => <strong>{chunks}</strong> }
                            )}
                        </span>
                    </div>

                    <div className="flex justify-end gap-3">
                        <button type="button" className="btn btn-default" onClick={props.onClose}>
                            {intl.formatMessage({ id: "occurrence.import.close" })}
                        </button>
                    </div>
                </div>
            }
        />
    );
}